import script from "./CustomerInputSummaryBlock.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerInputSummaryBlock.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerInputSummaryBlock.vue?vue&type=style&index=0&id=a6d6f3b2&scoped=true&lang=scss"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6d6f3b2"]])

export default __exports__